exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img{max-width:100%}.igo-layer-legend.with-title{padding-left:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/lib/layer/layer-legend/layer-legend.component.styl
// module id = 1047
// module chunks = 0